import { defMathOp } from "./internal/codegen";
export const [sub, sub2, sub3, sub4] = defMathOp("-");
